import { useCallback, useMemo } from 'react';
import useUserClaims from './useUserClaims';

export default function useEligibleServices() {
  const claims = useUserClaims();
  const eligibleServices = useMemo(
    () => claims?.eligible_services?.split(',').map((i) => Number.parseInt(i, 10)) ?? [],
    [claims]
  );
  const isEligible = useCallback(
    (serviceId) => eligibleServices.includes(serviceId),
    [eligibleServices]
  );

  return { isEligible };
}
